import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import { useCallback, useMemo } from 'react';
import { EventName } from '../types';
import evIdParams from '../utils/eventsParams';

export default function useBiLogger() {
  let logger: any;
  const Wix = window.Wix;
  const endpoint =
    Wix?.Utils.getViewMode() === 'site' ? 'wixlabs-ugc' : 'wixlabs-users';
  const initLogger = () => {
    logger = iframeAppBiLoggerFactory(window.Wix, {
      endpoint,
    })
      .setEvents({})
      .updateDefaults({
        src: 63,
        biToken: (Wix && Wix.Utils.getInstanceValue('biToken')) || '',
        app_site_id: (Wix && Wix.Utils.getInstanceId()) || '',
        instance_id: (Wix && Wix.Utils.getOrigCompId()) || '',
        hosting: endpoint,
      })
      .logger();
  };

  initLogger();
  const report = useCallback(
    (evName: EventName) => {
      return logger.log({ ...evIdParams[evName].params });
    },
    [logger],
  );
  const reportLog = useMemo(() => ({ report }), [report]);
  return reportLog;
}
